import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconGraph, IconRewindPlay, IconToggle } from '@posthog/icons';
import ChannelPlatforms from "../../../../contents/docs/workflows/_snippets/channel-platforms";
import OSButton from 'components/OSButton';
import Beta from "../../../../contents/docs/workflows/_snippets/beta.mdx";
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  IconGraph,
  IconRewindPlay,
  IconToggle,
  ChannelPlatforms,
  OSButton,
  Beta,
  React
};